// export const getUserId = (state) => state.user._id;
import { AppState } from "../rootReducer";
import { createSelector } from "reselect";
import { getAccessToken } from "../token/selector";

export const getUser = (state: AppState) => state.user;

export const getUserId = (state: AppState) => state.user._id || state.user.id;

export const getClientId = (state: AppState) => state.user.client;

export const getUserEmail = (state: AppState) => state.user.email || "";


export const getUserGoalNumber = (state: AppState) => {
  return state.user.goalNumber || 3;
};

/*export const getUserFriends = (state: AppState) =>
  state.user.friends.filter(el => el.status === "accepted");
*/

export const getUserProfilePictureUrl = (state: AppState) => state.user.picture;

export const getHasMbti = (state: AppState) => state.user.hasMbti !== false;

export const getMbti = (state: AppState) => state.user.mbti;

export const getHasAvatars = (state: AppState) =>
  state.user.hasAvatars !== false;

export const getUserFirstName = (state: AppState) => state.user.firstName || "";

export const getUserLastName = (state: AppState) => {
  return state.user.lastName || "";
};

export const getUserLanguage = (state: AppState) => state.user.language || "fr";

export const getUserSkills = (state: AppState) => state.user.skills || [];

// export const getUserName = createSelector(
//   getUserFirstName,
//   getUserLastName,
//   (firstName, lastName) => {
//     return `${firstName} ${lastName}`;
//   },
// );

export const getUserExperience = (state: AppState) => state.user.experience;

export const getUserRank = (state: AppState) => state.user.rank;

export const getUserTimezone = (state: AppState) =>
  state.user.timezone || "Europe/Paris";

export const getHasNotificationsEnabled = (state: AppState) =>
  state.user.hasNotificationsEnabled || false;

export const getUserRole = (state: AppState) => state.user.role || "user";

export const getChallengeReminderTime = (state: AppState) =>
  state.user.challengeReminderTime || { hour: 18, minute: 30 };

export const getHasChallengeReminder = (state: AppState) =>
  state.user.hasChallengeReminder || false;

export const getUserPicture = (state: AppState) => state.user.picture;

export const getUserCreationDate = (state: AppState) => state.user.createdAt;

export const getHasCompleteOnboarding = (state: AppState) =>
  state.user.hasCompleteOnboarding || false;

export const getPulseRequesting = (state: AppState) =>
  state.user.pulseRequesting || false;

export const getUserCurrentStreak = (state: AppState) => state.user.currentStreak;

export const getIsLoggedIn = createSelector(
  getAccessToken,
  getHasCompleteOnboarding,
  (accessToken, hasCompleteOnboarding) => {
    const isLoggedIn = accessToken !== null && hasCompleteOnboarding;
    return isLoggedIn;
  },
);
